// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 5.5V11H21V21H3V3L9 5.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M13 16V21H17V16H13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M13 16V21H17V16H13Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 21V11M9 21H21V11H9M9 21H3V3L9 5.5V11","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city')
export default class CityIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city',
    }
  }
}
